import React, { useCallback, useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import { GET_ANNUAL_STATEMENT_DOCUMENTS, GET_COMPILANCE_OPINIONS_DOCUMENTS, GET_ENTERPRISE_BY_ID, GET_FILE_TYPES, GET_FINANCIAL_REPORTING, GET_LEGAL_ENTITIE_DOCUMENTS, GET_MAILBOX, GET_NATURAL_PERSON_DOCUMENTS, GET_PROVISIONAL_PAYMENTS_DOCUMENTS } from "../../../api/apiEmpresas";
import AccesosDirectosDocuments from "../../organisms/empresas/AccesosDirectosDocuments";
import { useNavigate } from "react-router-dom";
import useModal from "../../../hooks/useModal";
import Modal from "../../molecules/Modal";
import ReactSelect from "react-select";
import EmpresaHeader from "../../organisms/clientes/empresas/headers/EmpresaHeader";
import ModalSuggestionForm from "../../organisms/clientes/empresas/contador/ModalSuggestionForm";
import { useSession } from "../../../context/SessionContext";

const EmpresasTemplate = ({ id }) => {
    const [loading, setLoading] = useState(false);
    const [empresa, setEmpresa] = useState();
    const [documentosBuscables, setDocumentosBuscables] = useState([]);
    const { open: openQuejas, close: closeQuejas, isOpen: isOpenQuejas } = useModal();
    const navigate = useNavigate();
    const { user } = useSession();

    const fetchAllDocuments = useCallback(async (empresa, fileTypes) => {
        const tablas = [
            {name: "ARCHIVO PERMANENTE", tableName: "archivo_permanente"},
            {name: "DECLARACIÓN ANUAL", tableName: "declaracion_anual"},
            {name: "PAGOS PROVISIONALES", tableName: "pagos_provicionales"},
            {name: "OPINIONES DE CUMPLIMIENTO", tableName: "opiniones_cumplimiento"},
            {name: "REPORTES FINANCIEROS", tableName: "reportes_financieros"},
            {name: "ESTADO DE CUENTA", tableName: "estado_cuenta"},
            {name: "BUZONES", tableName: "buzones"},
        ];

        const extractDocumentsFromObject = (obj, tabla, empresa) => {
        if (!obj) return [];

        return Object.entries(obj)
            .filter(([key]) => {
                return fileTypes.some(t => t.tableName === key)
            })
            .map(([key]) => {
                const tipoEncontrado = fileTypes.find(t => t.tableName ===  key);
                const tablaEncontrada = tablas.find(t => t.tableName ===  tabla);

                return {
                    label: `${tipoEncontrado?.name || key.replace(/_/g, " ")} - ${tablaEncontrada?.name}`,
                    value: {
                        key,
                        tabla,
                        empresaName: empresa.name,
                        empresaId: empresa.id,
                        ruta: `/clientes/empresas/${empresa.id}/${tabla}/${key}`
                    }
                };
            });
        };

        const id = empresa.id;
        const responses = [];
    
        if (empresa.type === "NaturalPerson") {
            const docs = await GET_NATURAL_PERSON_DOCUMENTS(id);
            responses.push(...extractDocumentsFromObject(docs, "archivo_permanente", empresa));
        } else {
            const docs = await GET_LEGAL_ENTITIE_DOCUMENTS(id);
            responses.push(...extractDocumentsFromObject(docs, "archivo_permanente", empresa));
        }
    
        const compliance = await GET_COMPILANCE_OPINIONS_DOCUMENTS(id);
        responses.push(...extractDocumentsFromObject(compliance, "opiniones_cumplimiento", empresa));
    
        const anual = await GET_ANNUAL_STATEMENT_DOCUMENTS(id);
        responses.push(...extractDocumentsFromObject(anual, "declaracion_anual", empresa));
    
        const pagos = await GET_PROVISIONAL_PAYMENTS_DOCUMENTS(id);
        responses.push(...extractDocumentsFromObject(pagos, "pagos_provicionales", empresa));
    
        const reportes = await GET_FINANCIAL_REPORTING(id);
        responses.push(...extractDocumentsFromObject(reportes, "reportes_financieros", empresa));

        const buzones = await GET_MAILBOX(id);
        responses.push(...extractDocumentsFromObject(buzones, "buzones", empresa));
        return responses;
    }, []);

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const empresaData = await GET_ENTERPRISE_BY_ID(id);
                setEmpresa(empresaData);
                const fileTypesData = await GET_FILE_TYPES();
                const docs = await fetchAllDocuments(empresaData, fileTypesData);
                setDocumentosBuscables(docs);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [id, fetchAllDocuments]);

    const handleSelectDocument = (selectedOption) => {
        navigate(selectedOption.value.ruta);
    };

    return(
        <div className="space-y-2">
            <EmpresaHeader 
                empresa={empresa}
            />
            {user?.role === "Client" && user?.roleInfo?.isAllowed === false ?
                <div className="text-center">
                    <p>Contacta con tu asesor</p>
                </div>
            :
                (empresa && !loading ?
                    <div>
                        <ReactSelect
                            options={documentosBuscables}
                            placeholder="Buscar documento..."
                            onChange={handleSelectDocument}
                            isSearchable
                        />
                        <AccesosDirectosDocuments empresa={empresa} />
                        <p className="hidden underline text-right text-slate-500 cursor-pointer p-4" onClick={()=> openQuejas()}>Quejas ó sugerencias</p>
                    </div>
                :
                    <div className="w-full h-full flex justify-center items-center">
                        <PropagateLoader color="red" />
                    </div>
                )
            }
            {isOpenQuejas &&
                <Modal title="Quejas o sujerencias" onClose={closeQuejas} >
                    <ModalSuggestionForm empresa={empresa} onClose={closeQuejas} />
                </Modal>
            }
        </div>
    )
};

export default EmpresasTemplate;